var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"item-action",class:`action-button-${_vm.id}`,attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.handleAction.apply(null, arguments)}}},[_c('span',{staticClass:"icon"},[_c('dash-icon',{attrs:{"icon":_vm.icon,"alt":_vm.label}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }